import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import gmail from "../../assets/google-svgrepo-com.svg";
import logo from "../../assets/flaplogo.png";
import signup from "../../assets/signup.gif";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle.js";
import SingleDropdown from "../../components/SingleDropdown.js";
import { MdEdit } from "react-icons/md";
import Tooltip from "../../components/Tooltip.js";
import countryCodes from "../../data/countryCode.js";

import axios from "axios";
import SmallLoader from "../../components/SmallLoader";
import constant from "../../constant/constant";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/authSlice.js";
import { useNavigate } from "react-router-dom";
import {useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import moment from 'moment';
import 'moment-timezone';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

const Signup = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signUpData, setSignUpData] = useState({
    userid:0,
    name: "",
    email: "",
    mobile: "",
    mobilestatus: 0,
    countryCode: { value: "+91", label: "+91" },
    dob: null,
    gender: {},
    intersetedIn: {},
    otp: ["", "", "", ""],
    agreeToTerms: true,
    emailstatus:0
  });
  const [timer, setTimer] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const inputRefs = useRef([]);
  const [sError, setSError] = useState({});
  const [showError, setShowError] = useState("");
  const [showErrorEmail, setShowErrorEmail] = useState("");
  const [gLoginUser, setGLoginUser] = useState([]); 
  const [success, setSuccess] = useState("");
  const [dataStatus, setDataStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [optboxis, setOtpBoxIs] = useState(false);
  const [emailmobilereadonly, setEmailMobileReadonly] = useState(false);
  useTitle("Signup - Create Your Account - Flapone Aviation");
  const countryCodeOptions = countryCodes;

  useEffect(() => {
    mobileOTPGenrate();
  }, [timer, isResendDisabled, signUpData.mobile.length,signUpData.countryCode]);


  function mobileOTPGenrate(){
    let interval;
    if(signUpData.mobile.length<10){
      setTimer(30);
      setIsResendDisabled(true);
    }
    if (isResendDisabled && signUpData.mobile.length > 5 &&  validateUser(signUpData)) {
      interval = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      if(timer==30){
        if(signUpData.userid<=0){
          checkMobileExist("mobile");
        }else if(signUpData.countryCode.value==='+91' && signUpData.mobile.length === 10){
          sendOTPValidate();
        }
      }
    }
    if (timer === 0) {
      setIsResendDisabled(false);
      clearInterval(interval);
    }
    
    return () => clearInterval(interval);
  }  

  const handleChange = (e) => {
    const { id, value, type, name } = e.target;
    if(id=="mobile"){
      const updatedRecord = { 
        ...signUpData, 
        mobilestatus: 0
      };
      setSignUpData(updatedRecord);
    }
    if (type === "radio") {
      setSignUpData({
        ...signUpData,
        [name]: value,
      });
    } else {
      setSignUpData({
        ...signUpData,
        [id]: value,
      });
    }
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^\d+$/.test(value) && index >= 0 && index < 4) {
      const newOtp = [...signUpData.otp];
      newOtp[index] = value;
      setSignUpData({
        ...signUpData,
        otp: newOtp,
      });
      if (index < 3 && value !== "") {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleBackspace = (e, index) => {
    if (e.keyCode === 8) {
      const newOtp = [...signUpData.otp];      
      if (index === 0) {
        newOtp[index] = "";
      } else {
        newOtp[index] = "";
        inputRefs.current[index - 1].focus();
      }  
      setSignUpData({
        ...signUpData,
        otp: newOtp,
      });
    }
  };

  const handleResendOtp = () => {
    setTimer(30);
    setIsResendDisabled(true);
  };

  const handleDateChange = (date) => {
    const momentUtc = moment.utc(date);
    const momentIst = momentUtc.tz('Asia/Kolkata');
    const formattedDate = momentIst.format('YYYY-MM-DD');
    setSignUpData({
      ...signUpData,
      dob: formattedDate,
    });
  };

  function validateUser(user) {
    // Check if name is not blank
    setShowError("");
    const newErrors = {};
    if (!user.name || user.name.trim() === '') {
        newErrors.name = "Name can't be blank.";
    }
    if(user.emailstatus>0){
      newErrors.email = "This email id already exists. Please login";
    }
    // Check if email is not blank and has a valid format
    if (!user.email || user.email.trim() === '') {
      newErrors.email = "Email can't be blank.";
    } else {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(user.email)) {
          newErrors.email = "Invalid email format.";
        }
    }
    // Check if mobile is not blank and validate mobile number with country code
    if (!user.mobile || user.mobile.trim() === '') {
      newErrors.mobile = "Mobile number can't be blank";
    }else {
      const mobilePattern = /^\d{10}$/; // Validates a 10-digit number
      const countryCode = user.countryCode.value;
      if (countryCode == '+91') {
        if (!mobilePattern.test(user.mobile)) {
          newErrors.mobile = "Please enter a valid 10-digit mobile number";
          //return false;
        }else {
          // Validate that the mobile number starts with an Indian digit (7, 8, 9)
          const validStartingDigits = /^[6789]/;
          if (!validStartingDigits.test(user.mobile)) {
            newErrors.mobile = "Indian mobile number must start with 6, 7, 8, or 9.";
            //return false;
          }
        }
      }
    }
    console.log("asfdsdfsfsdf","newErrors",newErrors);
    if (Object.keys(newErrors).length > 0) {
      setSError(newErrors);
      return false;
    }
    
    return true;
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    if(validateUser(signUpData)){
    axios({
      method: 'post',
      url: `${constant.base_url}/student/signup_student.php?fun=signupuser`,
      headers: {},
      data: {
        userdata: signUpData,
        type:"student",
      }
    }).then(function(response){
        if(response.data.data.status==="3"){
            autologin();
        }else if(response.data.data.status==="5"){
          let newErrors = {}
          if (String(response.data.data.msg).includes("mobile")){
            newErrors.mobile = response.data.data.msg;
          }else{
            newErrors.email = response.data.data.msg;
          }
          if (Object.keys(newErrors).length > 0) {
            setSError(newErrors);
          }
        }else if(response.data.data.status==="0"){
          let newErrors = {}
          if(response.data.data.error!==undefined){
            setSError(response.data.data.error);
          }else{
            let newErrors = {}
            if(response.data.data.msg.toLowerCase()!='enter otp'){
              newErrors.email = response.data.data.msg;
            }
            if (Object.keys(newErrors).length > 0) {
              setSError(newErrors);
            }
          }
        }
        setShowError(response.data.data.msg);
    }).catch(function(error) {
        console.error('Error during login:', error);
    });
    }
  };
  function  autologin(){
    let decodedata = btoa(btoa(signUpData.email+"|student"));
    axios({
      method: 'post',
      url: `${constant.base_url}/login_student.php?fun=autologin`,
      headers: {},
      data: {
        id:decodedata,
        type:'student',
        page:"signup",
      }
      }).then(function(response) {
      if(response.data.data.status === '1'){
          const logdata  = response.data.login.data;
          const redirectpage = response.data.data.type;
          dispatch(setUser(logdata));
          setSuccess(response.data.data.msg);
          localStorage.setItem("flaponestudentlogdetails", btoa(btoa(JSON.stringify(logdata))));
            if(redirectpage === "forgot_password"){
              navigate("/my-account?tab=Settings&section=newpass");
            }else if(redirectpage === "email_verify"){
              navigate("/my-account?tab=settings");
            }else if(redirectpage === "invitaion_accept"){
              navigate("/my-account?tab=settings");
            }else{
            navigate("/my-account");
            }
        }else{
          setShowError(response.data.msg);
      }
    });
  }
  const sendOTPValidate  =()=>{
    if(validateUser(signUpData)){
    axios({
      method: 'post',
      url: `${constant.base_url}/student/signup_student.php?fun=optgenrate`,
      headers: {},
      data: {
        userdata: signUpData,
        type:"student",
      }
    }).then(function(response){
        setShowError(response.data.data.msg);
        if(response.data.data.user_id<=0 && response.data.data.error!==undefined){
          setSError(response.data.data.error);
        }
        if(String(response.data.data.msg).includes("email")){
          let newErrors = {}
          newErrors.email = response.data.data.msg;
          if (Object.keys(newErrors).length > 0) {
            setSError(newErrors);
          }
        }else if (String(response.data.data.msg).includes("mobile")){
          let newErrors = {}
          newErrors.mobile = response.data.data.msg;
          if (Object.keys(newErrors).length > 0) {
            setSError(newErrors);
          }
        }else if(response.data.data.user_id>0){
          setSignUpData({
            ...signUpData,
            userid: parseInt(response.data.data.user_id),
          });
          setOtpBoxIs(true);
          setEmailMobileReadonly(true);
        }
    }).catch(function(error) {
        console.error('Error during login:', error);
    });
    }
  }
  
  const handleCheckboxChange = (event) => {
    setSignUpData((prevState) => ({
      ...prevState,
      agreeToTerms: event.target.checked,
    }));
  };

  const customDateFormat = "dd/MM/yyyy";
  const startDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 15)
  );
  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "not prefer", label: "Prefer Not To Say" },
  ];
  const [interestOptions,setInterestOptions] = useState([]); 
  const mobileInputRef = useRef(null);
  const handleMobileEditClick = () => {
    if (mobileInputRef.current) {
      mobileInputRef.current.focus();
    }
  };
  const getCourseCategory = (checktype) =>{
    axios({
      method: 'post',
      url: `${constant.base_url}/student/signup_student.php?fun=getcoursecategory`,
      headers: {},
      data: {}
    }).then(function(response){
        const coursecategory = JSON.parse(response.data.data.data);
        setInterestOptions(coursecategory);
        setDataStatus(true);
    }).catch(function(error) {
      // Handle errors
      console.error('Error during login:', error);
    });
  }
  const checkEmailIsExist = (checktype) =>{
    setShowError("");
    setSError({});
    if(signUpData.email || signUpData.mobile){
      axios({
        method: 'post',
        url: `${constant.base_url}/student/signup_student.php?fun=checkemailexist`,
        headers: {},
        data: {
          userdata: signUpData,
          type:"student",
          checktype:checktype
        }
      }).then(function(response){
          const loginUser = response.data.data;
            const updatedRecord = { 
              ...signUpData, 
              emailstatus: loginUser.status,
            };
            setSignUpData(updatedRecord);
            if(loginUser.status>0){
              let newErrors = {}
              newErrors.email = response.data.data.msg;
              if (Object.keys(newErrors).length > 0) {
                setSError(newErrors);
              }
            }else{
              mobileOTPGenrate();
            }
      }).catch(function(error) {
        // Handle errors
        console.error('Error during login:', error);
      });
    }
  }
  function checkMobileExist (checktype){
    setShowError("");
    setSError({});
    if(signUpData.email || signUpData.mobile){
      axios({
        method: 'post',
        url: `${constant.base_url}/student/signup_student.php?fun=checkemailexist`,
        headers: {},
        data: {
          userdata: signUpData,
          type:"student",
          checktype:checktype
        }
      }).then(function(response){
          const loginUser = response.data.data;
            const updatedRecord = { 
              ...signUpData, 
              mobilestatus: loginUser.status,
            };
            setSignUpData(updatedRecord);
            if(loginUser.status>0){
              let newErrors = {}
              newErrors.mobile = response.data.data.msg;
              if (Object.keys(newErrors).length > 0) {
                setSError(newErrors);
              }
            }else {
              if(signUpData.countryCode.value==='+91' && signUpData.mobile.length === 10){
                sendOTPValidate();
              }
            }
      }).catch(function(error) {
        // Handle errors
        console.error('Error during login:', error);
      });
    }
  }

  useEffect(()=>{
    getCourseCategory();
  },[]);

  useEffect(()=>{
      
  },[signUpData])

   /************************Google Login Code*******************************/

   const handleGoogleLoginSuccess = (codeResponse) => {
    // Set the gLoginUser state
    setGLoginUser(codeResponse);
    // Call the googleSignin function with the codeResponse
    googleSignin(codeResponse);
  };
  
  const login = useGoogleLogin({
    onSuccess:handleGoogleLoginSuccess,
    onError: (error) => console.log("Login Failed:", error),
  });
  function googleSignin(gLoginUser){
    if (gLoginUser) {
      axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${gLoginUser.access_token}`, {
        headers: {
          Authorization: `Bearer ${gLoginUser.access_token}`,
          Accept: 'application/json',
        },
      })
      .then((res) => {
        createGoogleUser(gLoginUser, res.data);
      })
      .catch((err) => {
        console.error(err);
      });
    }
  }

  const createGoogleUser = async (gLoginUser, gLoginProfile) => {
    if (gLoginProfile) {
      const updatedRecord = { 
        ...signUpData, 
        email: gLoginProfile.email,
        name: gLoginProfile.name,

      };
      setSignUpData(updatedRecord);
    }
    axios({
      method: 'post',
      url: `${constant.base_url}/login_student.php?fun=loginbygoogle`,
      headers: {},
      data: {
        userdata: gLoginUser,
        userprofile: gLoginProfile,
        type:"student",
      }
    }).then(function(response){
        const loginUser = response.data.login.data;
        if (loginUser && loginUser.user_id !== "" && loginUser.user_id!==undefined) {
          //dispatch(setUser(loginUser));
          //localStorage.setItem("flaponestudentlogdetails", btoa(btoa(JSON.stringify(loginUser))));
          //navigate("/");
          let newErrors = {}
          newErrors.email = response.data.data.msg;
          if (Object.keys(newErrors).length > 0) {
            setSError(newErrors);
          }

        }
     else{
        //setShowError(response.data.data.msg);
     }
    }).catch(function(error) {
      // Handle errors
      console.error('Error during login:', error);
    });
  };

  /****************************End Google Login Code*******************************/
  return (
    <>
    {dataStatus && <div className="login-container df">
      <div className="left-side flx45">
        <div className="image-container pr w100">
          <img src={signup} alt="Login" className="image" />
          <div className="overlay-s h-center aie fc1 pa t0 b0 l0 r0">
            <p className="overlay-text fs16 fw6 pb32 lh28 ls1 tac">
              Sign up to get access to valuable materials and updates related to
              Drone/Aircraft Pilot Training.
            </p>
          </div>
        </div>
      </div>
      <div className="right-side bg1 df fdc flx1">
        <div className="flx100 box-center fdc">
          <div className="box-center w100 fdc mb16">
            <img src={logo} alt="logo" className="logo" />
            <div className="head-text mt24 mb16 box-center fdc">
              <p className="fs24 fc2 ls1 mb8 tac">Sign Up</p>
              <p className="fs14 fc6 tac">
                Create your account to start your journey with us and access
                exclusive resources.
              </p>
            </div>
          </div>
          <form className="w100">
            <div className="login-form-grp df jcsb mb16">
              <div className="left-inp flx48">
                <label htmlFor="name" className="df fs16 ls1 fw6">
                  Name<span className="fc5">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  placeholder="Enter name"
                  autoComplete="off"
                  value={signUpData.name}
                  onChange={handleChange}
                  className={sError.name ? 'error-input' : ''}
                />
                {sError.name &&  <p className="error-message">{sError.name}</p>}
              </div>
             
              <div className="left-inp flx48">
                <label htmlFor="email" className="df fs16 ls1 fw6">
                  Email<span className="fc5">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter email"
                  autoComplete="off"
                  value={signUpData.email}
                  onChange={handleChange}
                  onBlur={()=>checkEmailIsExist('email')}
                  className={`${
                    emailmobilereadonly
                      ? "bg4 not-allowed"
                      : sError.email ? 'error-input' : ''
                  }`}
                  disabled={emailmobilereadonly}
                />
                 
                 {sError.email && <p className="error-message">{sError.email}</p>}
              </div>
            </div>

            <div className="login-form-grp df jcsb mb16">
              <div className="left-inp flx48">
                <label htmlFor="mobile" className="df fs16 ls1 fw6">
                  Mobile<span className="fc5">*</span>
                </label>
                <div className="mob-conatiner df">
                  <div className="flx33">
                    <SingleDropdown
                      isReadOnly={emailmobilereadonly}
                      options={countryCodeOptions}
                      selectedOption={signUpData.countryCode}
                      onSelect={(option) => {
                        setSignUpData((prevData) => ({
                          ...prevData,
                          countryCode: option,
                          mobile:""
                        }));
                      }}                      
                    />
                  </div>
                  <input
                    type="number"
                    id="mobile"
                    autoComplete="off"
                    placeholder="Enter mobile number"
                    value={signUpData.mobile}
                    onChange={handleChange}
                    ref={mobileInputRef}
                    className={`${
                      emailmobilereadonly
                        ? "bg4 not-allowed"
                        : sError.mobile ? 'error-input' : ''
                    }`}
                    
                    disabled={emailmobilereadonly}
                  />
                   
                </div>
                {sError.mobile && <p className="error-message">{sError.mobile}</p>}
                {sError.countryCode && <p className="error-message">{sError.countryCode}</p>}
              </div>
              <div className="left-inp flx48">
                <SingleDropdown
                  label="Interested In"
                  options={interestOptions}
                  selectedOption={signUpData.intersetedIn}
                  onSelect={(option) =>
                    setSignUpData({ ...signUpData, intersetedIn: option })
                  }
                />
              </div>
            </div>
            <div className="login-form-grp df jcsb mb16">
              <div className="left-inp flx48">
                <label htmlFor="dob" className="df fs16 ls1 fw6">
                   DOB{/*<span className="fc5">*</span> */}
                </label>
                <DatePicker
                  dateFormat={customDateFormat}
                  selected={signUpData.dob}
                  onChange={handleDateChange}
                  placeholderText="Select DOB"
                  startDate={startDate}
                  openToDate={startDate}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>

              <div className="left-inp mb20 flx48">
                <SingleDropdown
                  label="Gender"
                  options={genderOptions}
                  selectedOption={signUpData.gender}
                  onSelect={(option) =>
                    setSignUpData({ ...signUpData, gender: option })
                  }
                />
              </div>
              {sError.gender && <p className="error-message">{sError.gender}</p>}
            </div>

            {optboxis && (
              <div className="login-form-grp df fdc ">
                <label htmlFor="otp" className="df fs16 ls1 fw6">
                  Enter OTP{optboxis}<span className="fc5">*</span>
                </label>
                <div className="otp-inputs box-center fdc">
                  <p className="fs14 ls1 lh14 fc6 v-center">
                    We've sent an OTP to your mobile number{" "}
                    {`${signUpData.countryCode.label}${signUpData.mobile}`}
                    {/* <span>
                      <Tooltip title="Change Number">
                        <MdEdit
                          className="fs16 cp ml4"
                          onClick={handleMobileEditClick}
                        />
                      </Tooltip>
                    </span> */}
                  </p>
                  <div className="input-otp box-center mt8">
                    {signUpData.otp.map((value, index) => (
                      <input
                        key={index}
                        type="text"
                        className="otp-input"
                        value={value}
                        maxLength="1"
                        onChange={(e) => handleOtpChange(e, index)}
                        onKeyDown={(e) => handleBackspace(e, index)}
                        ref={(input) => (inputRefs.current[index] = input)}
                      />
                    ))}
                  </div>
                  <p className="fs14 ls1 lh14 mb24 fc6 v-center">
                    Don't receive the OTP?{" "}
                    <span
                      className={` cp v-center ml4 ${
                        isResendDisabled ? "not-allowed fc6 " : "fc3 "
                      }`}
                      onClick={!isResendDisabled ? handleResendOtp : undefined}
                    >
                      RESEND OTP{" "}
                      {isResendDisabled && (
                        <p className="fs14 ls1 lh14 fc6 ml12">{`in 00:${timer
                          .toString()
                          .padStart(2, "0")}`}</p>
                      )}
                    </span>
                  </p>
                </div>
              </div>
            )}
             {showError && <div className="warn-msg box-center mb8 fs14 ls1 fc3 cp">
             {showError}
            </div>}
            <div className="df aic jcc ls1 fc16 ais mb8 fs12">
              <input
                type="checkbox"
                id="agreeCheckbox"
                className="mr8"
                checked={signUpData.agreeToTerms}
                //onChange={handleCheckboxChange}
              />
              
              <label htmlFor="agreeCheckbox" className="fsi">
                I agree to get Email/SMS from you
              </label>
            </div>
           
            <button
              type="submit"
              className={`h40 login-button bg3 fc1`}
              // disabled={
              //   signUpData.mobile.length !== 10 ||
              //   signUpData.otp.some((value) => value === "")
              // }
              onClick={(e)=>handleSubmit(e)}
            >
              Sign Up
            </button>
          </form>
          <div className="alternative-login box-center fdc">
            <p className="or-login-text fc6 fs14 box-center w100">
              Or, Sign Up with
            </p>
            <button className="h40 google-login w100 fc2 box-center brd1 br4 cp bg1" onClick={(e) => {e.preventDefault();login();}}>
              <img src={gmail} alt="Google Logo" className="mr8" />
              Sign up with Google
            </button>
          </div>
          <div className="box-center w100 fs14 ls1 register">
            Already have an account?{" "}
            <span className="ml8 fc3 cp">
              <Link to="/login">Login Here</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
    }
    </>
  );
};

export default Signup;
